export const DOMAIN_RATECHAPP = 'ra-techapp.com';
